import { render, staticRenderFns } from "./NewOrderAlert.vue?vue&type=template&id=b8116682&"
import script from "./NewOrderAlert.vue?vue&type=script&lang=js&"
export * from "./NewOrderAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports